import Misc from 'src/utils/helper/misc'

const currentDate = new Date();
const start = new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate());

export const requestObj = {
    fromDate: Misc.formatDate(new Date(start), 'en', 'YYYY-MM-DD'),
    toDate: Misc.formatDate(new Date(currentDate), 'en', 'YYYY-MM-DD'),
    searchQuery: '',
    foundryIds: [],
    salesChannel: [],
    showRefundsOnly: false,
    includeDemoFonts: true,
    pageNumber: '1',
    isOrderListViewCall: '',
    isMoreOrderListViewCall: '',
    fields: 'orderDate',
    sortType: 'DESC',
    itemsPerPage: '20',
    cjaEvent: null
}